import React, { useState, useEffect } from "react";
import {
  LogoutOutlined,
  UserOutlined,
  SettingOutlined,
  HomeOutlined,
  AppstoreOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CrownOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  Button,
  Avatar,
  Typography,
  Divider,
  Drawer,
  Grid,
} from "antd";
import { useNavigate, useLocation, Link } from "react-router-dom";
import logo from "../src/Assets/Logo.svg";
import { CiSquareQuestion } from "react-icons/ci";
const { Sider } = Layout;
const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

const AdminNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detectar se é mobile
  useEffect(() => {
    setIsMobile(!screens.lg);
    if (!screens.lg) {
      setCollapsed(true);
    }
  }, [screens.lg]);

  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
      localStorage.removeItem("authToken");
      navigate("/auth");
      window.location.reload();
    } else {
      navigate(key);
      // Chiudi drawer su mobile dopo la navigazione
      if (isMobile) {
        setMobileDrawerVisible(false);
      }
    }
  };

  const menuItems = [
    {
      key: "/admin/dashboard",
      icon: <HomeOutlined />,
      label: "Dashboard",
    },
    {
      key: "/admin/user_management",
      icon: <UserOutlined />,
      label: "Gestione Utenti",
    },
    {
      key: "/admin/tools",
      icon: <SettingOutlined />,
      label: "Tools",
    },
    {
      key: "/admin/richiedi_demo",
      icon: <CiSquareQuestion />,
      label: "Richiedi Demo",
    },
    {
      key: "/",
      icon: <AppstoreOutlined />,
      label: "Moduli",
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: (
        <span className="admin-navbar-logout-text">
          Disconnetti
        </span>
      ),
      className: "admin-navbar-logout-item",
    },
  ];

  const siderContent = (
    <>
      {/* Header del Sidebar */}
      <div
        className={`admin-navbar-header ${collapsed && !isMobile ? 'collapsed' : ''}`}
      >
        {!collapsed || isMobile ? (
          <>
            <Link to="/">
              <img src={logo} alt="ExisMobility Logo" className="admin-navbar-logo" />
            </Link>
            <Title
              level={5}
              className="admin-navbar-title"
            >
              Pannello Admin
            </Title>
          </>
        ) : (
          <Avatar
            size={40}
            className="admin-navbar-avatar"
            icon={<CrownOutlined />}
          />
        )}
      </div>

      {/* Menu di Navigazione */}
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        onClick={handleMenuClick}
        items={menuItems}
        className="admin-navbar-menu"
      />

      {/* Footer del Sidebar */}
      {(!collapsed || isMobile) && (
        <div className="admin-navbar-footer">
          <Text className="admin-navbar-footer-text">
            v1.0.0 - Admin Dashboard
          </Text>
        </div>
      )}
    </>
  );

  // Render per desktop
  if (!isMobile) {
    return (
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        breakpoint="lg"
        collapsedWidth={80}
        width={260}
        className="admin-navbar-sider"
        trigger={
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            className="admin-navbar-trigger"
          />
        }
      >
        {siderContent}

      </Sider>
    );
  }

  // Render per mobile con Drawer
  return (
    <Sider>
      {/* Pulsante Menu Mobile */}
      <Button
        type="primary"
        icon={<MenuUnfoldOutlined />}
        onClick={() => setMobileDrawerVisible(true)}
        className="admin-navbar-mobile-trigger"
      />

      {/* Drawer Mobile */}
      <Drawer
        title={null}
        placement="left"
        closable={false}
        onClose={() => setMobileDrawerVisible(false)}
        open={mobileDrawerVisible}
        width={280}
        className="admin-navbar-mobile-drawer"
        bodyStyle={{
          padding: 0,
          background: "linear-gradient(180deg, var(--primary-color) 0%, var(--primary-dark) 100%)",
        }}
        headerStyle={{
          display: "none",
        }}
      >
        <div className="admin-navbar-mobile-container">
          {/* Pulsante Chiudi */}
          <Button
            type="text"
            icon={<MenuFoldOutlined />}
            onClick={() => setMobileDrawerVisible(false)}
            className="admin-navbar-mobile-close"
          />

          {siderContent}
        </div>
      </Drawer>

    </Sider>
  );
};

export default AdminNavbar;
